var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { Information, Warning } from '../../../../foundations/icons';
import { Typography } from '../../../../foundations/typography';
import styles from './FieldSubText.module.scss';
export var FieldSubText = function (_a) {
    var _b;
    var customClassName = _a.className, hideIcon = _a.hideIcon, text = _a.text, type = _a.type, props = __rest(_a, ["className", "hideIcon", "text", "type"]);
    var ariaLive = type === 'advisory' || type === 'error' ? 'polite' : undefined;
    var classNames = cx(styles.subtext, customClassName, (_b = {},
        _b[styles.error] = type === 'error',
        _b[styles.srOnly] = !text,
        _b));
    var leadingIcon;
    if (!hideIcon) {
        switch (type) {
            case 'error':
                leadingIcon = React.createElement(Warning, null);
                break;
            case 'help':
                leadingIcon = React.createElement(Information, null);
                break;
            default:
                break;
        }
    }
    return (React.createElement(Typography, __assign({}, props, { "aria-live": ariaLive, className: classNames, styleAs: "paragraphSmall" }),
        text && !!leadingIcon && React.createElement("span", { className: styles.icon }, leadingIcon),
        text));
};
//# sourceMappingURL=FieldSubText.js.map